
<script>
import handyUploader from 'handy-uploader/src/components/handyUploader';
import { getFirestore, collection, doc, setDoc } from 'firebase/firestore';
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
} from 'firebase/storage';

export default {
  name: 'StrappNewGroupPage',

  data: () => ({
    newGroup: {
      name: '',
      description: '',
      location: '',
      bannerImg: '',
    },
    image: '',
    handyAttachments: [],
    privacyLevel: 'Public',
  }),

  mounted() {},

  components: {
    handyUploader,
  },

  methods: {
    async uploadFiles() {
      return new Promise(async (resolve, reject) => {
        const storage = getStorage();
        // const db = getFirestore();
        // const storagePromises = [];
        const fileNames = [];
        let image = '';

        for (let i = 0; i < this.handyAttachments.length; i++) {
          const file = this.handyAttachments[i].file.base64;

          // console.log(file);
          const fileName = `${Date.now()}_${
            this.handyAttachments[i].file.name
          }`;
          console.log(fileName);
          fileNames.push(fileName);

          const storageRef = ref(
            storage,
            `groups/${this.newGroup.name}/${fileName}`
          );

          console.log(storageRef);

          const snapshot = await uploadString(storageRef, file, 'base64');
          const downloadURL = await getDownloadURL(snapshot.ref);

          image = downloadURL;

          console.log(downloadURL);
        }

        resolve(image);
      });
    },
    async addGroup() {
      // get images
      const photo = await this.uploadFiles();

      const db = getFirestore();

      const groupRef = doc(collection(db, 'groups'));

      let group = {
        name: this.newGroup.name,
        description: this.newGroup.description,
        createdAt: new Date(),
        createdBy: 'Strapp HQ',
        privacy: this.privacyLevel,
        Location: 'Western Cape',
        image: photo,
        userCount: '1',
        id: groupRef.id,
      };

      console.log(groupRef, group);

      await setDoc(groupRef, group);

      console.log(groupRef.id);
    },
  },
};
</script>


<template>
  <div class="d-flex justify-center">
    <v-row style="max-width: 1200px">
      <v-col cols="10" offset="1">
        <v-card color="#F7F7F7" class="pa-3 my-9 px-md-16 py-7 round">
          <p class="text-h4 text-center app--text">New Group</p>
          Group Name:
          <v-text-field
            v-model="newGroup.name"
            label="Group Name"
            solo
            class="round"
            hint="More than 6 characters"
            persistent-hint
            counter
            name="name"
            placeholder="Start typing..."
          >
          </v-text-field>

          <v-row>
            <v-col>
              Banner Image
              <handy-uploader
                ref="uploader"
                :documentAttachment.sync="handyAttachments"
                :fileUploaderType="'simple'"
                :maxFileSize="10240"
                :imageCompressor="true"
                :imageCompressLevel="0.8"
                :maxFileCount="1"
                :badgeCounter="true"
                :thumb="true"
                :changeFileName="true"
                :addFileDescription="true"
                :addFileTag="true"
                :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
                :btnColor="'#f8b58e'"
                :fontColor="'#FFFF'"
                :cardType="'raised'"
                class="my-10"
              >
              </handy-uploader>
            </v-col>
          </v-row>

          Description:
          <v-textarea
            v-model="newGroup.description"
            placeholder="Start typing..."
            color="rgb(34, 34, 34)"
            type="text"
            required
            solo
            hint="between 50 and 500 characters."
            class="round"
          >
          </v-textarea>

          <v-row class="mt-4">
            <v-menu
              style="z-index: 11 !important"
              class="round"
              offset-y
              solo
              transition="slide-y-transition"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  v-bind="[attrs]"
                  v-on="on"
                  rounded
                  outlined
                  elevation="4"
                  class="ml-3 round"
                  z-index="12"
                >
                  <v-row class="px-3">
                    <v-col cols="2" class="grid">
                      <v-icon>fas fa-lock</v-icon>
                    </v-col>
                    <v-col cols="8" class="offblack--text">
                      <v-card-text class="font-weight-medium app--text"
                        >Choose Privacy</v-card-text
                      >
                      <v-card-text class="mt-n6">{{
                        privacyLevel
                      }}</v-card-text>
                    </v-col>
                    <v-col cols="2" class="grid">
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
              <v-card class="list">
                <v-list class="list" dense>
                  <v-list-item-group>
                    <v-list-item @click="privacyLevel = 'Public'">
                      <v-row class="mb-n2 mt-n2 caption">
                        <v-col cols="1">
                          <v-icon class="mt-2">fas fa-globe-africa</v-icon>
                        </v-col>

                        <v-col cols="10">
                          <v-list-item-title> Public </v-list-item-title>
                          <v-list-item-subtitle>
                            Anyone can see who's in the group <br />
                            and what they post.
                          </v-list-item-subtitle>
                        </v-col>
                        <v-col cols="1" v-if="privacyLevel === 'Public'">
                          <v-icon class="mt-2">mdi-check</v-icon>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item @click="privacyLevel = 'Private'">
                      <v-row class="mb-n2 mt-n2 caption">
                        <v-col cols="1">
                          <v-icon class="mt-2">fas fa-lock</v-icon>
                        </v-col>

                        <v-col cols="10">
                          <v-list-item-title> Private </v-list-item-title>
                          <v-list-item-subtitle>
                            Only members can see who's in the group <br />
                            and what they post
                          </v-list-item-subtitle>
                        </v-col>
                        <v-col cols="1" v-if="privacyLevel === 'Private'">
                          <v-icon class="mt-2">mdi-check</v-icon>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-row>

          <v-btn
            @click="addGroup()"
            class="ebtn mt-12"
            :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
            type="submit"
            rounded
            color="accent"
            elevation="8"
          >
            Submit
          </v-btn>
        </v-card>
      </v-col>
      <!--
      <v-overlay v-if="showLoadingForCreateItem">
        <v-img :src="require('@/assets/svgs/gondola2.svg')" />
        Uploading your item...
      </v-overlay> -->
    </v-row>
  </div>
</template>

<style>
.round {
  border-radius: 12px;
}
</style>
